import type { CommandRiskLevel } from "../../types/commands";

export const RISK_STYLES: Record<CommandRiskLevel, { color: string; bg: string; border: string; label: string }> = {
  low: { color: "#67E8F9", bg: "rgba(34,211,238,0.12)", border: "rgba(34,211,238,0.4)", label: "Low" },
  medium: { color: "#FDE68A", bg: "rgba(250,204,21,0.12)", border: "rgba(250,204,21,0.4)", label: "Medium" },
  high: { color: "#FDBA74", bg: "rgba(251,146,60,0.14)", border: "rgba(251,146,60,0.45)", label: "High" },
  critical: { color: "#FCA5A5", bg: "rgba(248,113,113,0.14)", border: "rgba(248,113,113,0.5)", label: "Critical" },
};
